// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cfs-show-password {
  cursor: pointer;
  padding: 0px 8px;
}

::-ms-reveal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/toggleable-password-field/toggleable-password-field.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;AACJ;;AACA;EACI,aAAA;AAEJ","sourcesContent":[".cfs-show-password {\n    cursor: pointer;\n    padding: 0px 8px;\n}\n::-ms-reveal {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
